<template>
  <div class="g-fixed-right-btn">
    <button
      class="technology btn-item"
      @click="
        openLink('http://wpa.qq.com/msgrd?v=3&uin=40227889&site=qq&menu=yes')
      "
    >
      <span>技术<br />支持</span>
      <p class="info">
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=40227889&site=qq&menu=yes"
          target="_blank"
          >QQ：40227889</a
        >
      </p>
    </button>
    <button class="tel btn-item">
      <span>电话</span>
      <p class="info">0752-5283248</p>
    </button>
    <button
      class="service btn-item"
      @click="
        openLink('http://wpa.qq.com/msgrd?v=3&uin=920952173&site=qq&menu=yes')
      "
    >
      <span>客户<br />服务</span>
      <p class="info">
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=920952173&site=qq&menu=yes"
          target="_blank"
          >QQ：920952173</a
        >
      </p>
    </button>
    <button class="hot-line btn-item">
      <span>热线</span>
      <p class="info">0752-5283248</p>
    </button>
  </div>
</template>

<script>
import * as util from "assets/js/util";

export default {
  prop: {
    bgColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    openLink(url) {
      window.open(url, "_blank");
    }
  },
  components: {}
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "~assets/scss/compile";
@import "./fixed";
</style>



// WEBPACK FOOTER //
// src/components/common/fixed/fixed.vue